import { createContext } from "react";

const hpContext = createContext();

export default hpContext;